import React from "react";
import { Link, useLocation } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  const location = useLocation();

  if (location.pathname === "/checkout") return null;

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__links">
        <div>
          <p className="site-footer__heading">Navigation</p>
          <Link to="/shop?department=Woman" onClick={toTop}>
            Woman
          </Link>
          <Link to="/shop?department=Man" onClick={toTop}>
            Man
          </Link>
          <Link to="/shop?category=Denim%20Pants" onClick={toTop}>
            Denim
          </Link>
          <Link to="/shop?category=Leather" onClick={toTop}>
            Leather
          </Link>
        </div>
        <div>
          <p className="site-footer__heading">Company</p>
          <Link to="/about" onClick={toTop}>
            About us
          </Link>
          <Link to="/contact" onClick={toTop}>
            Contact
          </Link>
          <Link to="/faqs" onClick={toTop}>
            FAQs
          </Link>
          <Link to="/responsibility" onClick={toTop}>
            Responsibility
          </Link>
        </div>
        <div>
          <p className="site-footer__heading">Client care</p>
          <Link to="/shipping" onClick={toTop}>
            Shipping
          </Link>
          <Link to="/returns" onClick={toTop}>
            Returns
          </Link>
          <Link to="/size-guide" onClick={toTop}>
            Size guide
          </Link>
          <Link to="/care" onClick={toTop}>
            Materials & care
          </Link>
          <Link to="/terms" onClick={toTop}>
            Terms & conditions
          </Link>
          <Link to="/privacy" onClick={toTop}>
            Privacy notice
          </Link>
          <Link to="/cookies" onClick={toTop}>
            Cookie policy
          </Link>
          <Link to="/accessibility" onClick={toTop}>
            Accessibility
          </Link>
        </div>
        <div className="site-footer__contact">
          <p className="site-footer__heading">Contact</p>

          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
          <p>{siteConfig.legalName}</p>
          <p>
            {siteConfig.contact.addressLines.map((line) => (
              <React.Fragment key={line}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>

      <div className="site-footer__bottom">
        <Link className="site-footer__wordmark" to="/" onClick={toTop}>
          {siteConfig.logo.value}
        </Link>
        <p>
          © {new Date().getFullYear()} {siteConfig.legalName}.{" "}
          {siteConfig.currency.code} / EN
        </p>
      </div>
    </footer>
  );
}

export default Footer;
